import React, { FC } from "react";
import classNames from "classnames/dedupe";

export interface IProgressBarProps {
  /**
   * Text for the title
   */
  title?: string;
  /**
   * Defining the scale where the progress = maxValue/currentValue*100
   */
  values: { maxValue?: number; currentValue: number };
  /**
   * The custom set of css classes used to style component
   */
  classes?: {
    /**
     * applied to outer 'div' element
     */
    root?: string;
  };
}

const ProgressBar: FC<IProgressBarProps> = ({ title, values, classes }) => {
  const rootClasses = classNames("comparison-bar", classes?.root);
  const { maxValue = 10, currentValue } = values;
  return (
    <div className={rootClasses}>
      <div className="comparison-bar__name">{title}</div>
      <div className="comparison-bar__wrapper">
        <progress
          className="progress-bar"
          max={maxValue}
          value={currentValue}
          data-testid="comparison-bar__progress"
        />
        <div className="comparison-bar__value">{currentValue}</div>
      </div>
    </div>
  );
};

export default ProgressBar;
